








































































































































































import { Component, Prop, Mixins, Watch, PropSync } from 'vue-property-decorator';
import { AxTransparent } from '@/mixins';
import Hangul from 'hangul-js';

class State {
  leftValues: number[];
  rightValues: number[];
  searchText: string;

  constructor() {
    this.leftValues = [];
    this.rightValues = [];
    this.searchText = '';
  }
}
type StringMap = { [key: string]: string };

@Component
export default class AxDeviceSelect extends Mixins(AxTransparent) {
  state: State = new State();

  @Prop({ type: Array, default: () => [] })
  items!: StringMap[];

  @PropSync('selected', { type: Array, default: () => [] })
  $selected!: StringMap[];

  @Prop({ type: Boolean })
  disabled!: boolean;

  @Watch('items')
  onItemsGroupChanged() {
    this.state.leftValues = [];
    this.state.rightValues = [];
  }

  onAddClicked() {
    this.$selected = [
      ...this.$selected,
      ...this.remainItems.filter((x, idx) => this.state.rightValues.includes(idx))
    ].sort((a, b) => a['name'].localeCompare(b['name']));
    this.state.rightValues = [];
  }

  onRemoveClicked() {
    this.$selected = this.$selected
      .filter((x, idx) => !this.state.leftValues.includes(idx))
      .sort((a, b) => a['name'].localeCompare(b['name']));
    this.state.leftValues = [];
  }

  get remainItems() {
    return this.items
      .filter(x => this.$selected.findIndex(y => y.name === x.name) === -1)
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  get searchItem() {
    return this.state.searchText;
  }

  set searchItem(text: string) {
    this.state.searchText = text;
  }

  searchFilter(text: string) {
    if (!this.state.searchText.length) return true;

    const searcher = new Hangul.Searcher(this.state.searchText.trim());
    return searcher.search(text) !== -1;
  }
}
